export function convertKgsMilkSolidsToLitres (kgsOfSolids: number) {
  return ((kgsOfSolids / 0.0073) * 1.03) / 1000
}